/* eslint-disable import/no-default-export */
import { createRoot } from 'react-dom/client';
import { ModalLayerManagerProvider } from 'dibs-elements/src/ModalContainer/ModalLayerManager';
export default function makeOfferLauncher(options = {}) {
    const modalContainer = document.createElement('div');
    const {
        currency,
        itemId,
        selectedSkuId,
        environment,
        quantitySelected,
        shouldNotSendOfferMessage,
        launchOrigin,
        shouldLaunchContactDealer,
        gaLabel,
        page,
        onClose,
        onOpen,
    } = options;
    return import(
        /* webpackChunkName: "makeOfferModal" */
        '../src/MakeOfferModal/makeOfferAsyncImports'
    ).then(({ components, helpers }) => {
        const { MakeOfferModal, IntlProvider } = components;
        const { serverVars } = helpers;
        const root = createRoot(modalContainer, { identifierPrefix: 'offerModal' });

        root.render(
            <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
                <ModalLayerManagerProvider>
                    <MakeOfferModal
                        launchOrigin={launchOrigin}
                        environment={environment}
                        itemId={itemId}
                        selectedSkuId={selectedSkuId}
                        pageCurrency={currency}
                        quantitySelected={quantitySelected}
                        shouldNotSendOfferMessage={shouldNotSendOfferMessage}
                        shouldLaunchContactDealer={shouldLaunchContactDealer}
                        gaLabel={gaLabel}
                        page={page}
                        onClose={onClose}
                        onOpen={onOpen}
                    />
                </ModalLayerManagerProvider>
            </IntlProvider>
        );
    });
}
